<div
	tabindex="0"
	class="checkbox"
	[ngStyle]="{ 'background-color': value == true || (shared != null && shared == value) ? colorChecked : color }"
	[ngClass]="{ checked: value == true || (shared != null && shared == value), 'only-button': innerText === '', 'disabled-div': disable }"
	(click)="detectChanges()"
	(keydown.enter)="detectChanges()">
	<span [ngClass]="{ hideOnSmall: !forceText }" *ngIf="innerText !== ''">{{ innerText }}</span>
	<span *ngIf="!hideCheck && (value == true || (shared != null && shared == value)) && !disable"
		><fa-icon [ngClass]="{ toggleAnim: toggleAnim }" [icon]="icons.faCheck"></fa-icon
	></span>
	<span *ngIf="!hideUncheck && (value == false || (shared != null && shared != value)) && !disable"
		><fa-icon [icon]="icons.faTimes"></fa-icon
	></span>
</div>
